import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'

export const adminGetBoardList = createAsyncThunk(
  'ADMIN_GET_BOARD_LIST',
  async (params) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board`,
      params
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const adminCreateBoard = createAsyncThunk(
  'ADMIN_CREATE_BOARD',
  async ({data}) => {
    let options = {
      method: 'POST',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const adminUpdateBoard = createAsyncThunk(
  'ADMIN_UPDATE_BOARD',
  async ({data}) => {
    let options = {
      method: 'PUT',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/${data.boardId}`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const adminDeleteBoard = createAsyncThunk(
  'ADMIN_DELETE_BOARD',
  async ({boardId}) => {
    let options = {
      method: 'DELETE',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/${boardId}`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

const adminBoardSlice = createSlice({
  name: 'adminBoard',
  initialState: {
    isLoading: false,
    boardList: [],
    boards: {},
  },
  reducers: {
    clearBoardList: (state) => {
      state.boardList = []
    },
  },
  extraReducers: {
    [adminGetBoardList.pending]: (state) => {
      state.isLoading = true
    },
    [adminGetBoardList.rejected]: (state) => {
      state.isLoading = false
    },
    [adminGetBoardList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.boardList = payload.map(data => {
        state.boards[data.boardId] = data
        return data.boardId
      })
    },
  }
})

export const { clearboardList } = adminBoardSlice.actions

export default adminBoardSlice.reducer